"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightButton = exports.LeftButton = exports.StyledToggleButtons = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledToggleButtons = _styledComponents.default.div.withConfig({
  displayName: "ToggleButtonsstyles__StyledToggleButtons",
  componentId: "sc-4yw4dk-0"
})(["display:flex;"]);

exports.StyledToggleButtons = StyledToggleButtons;
var LeftButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "ToggleButtonsstyles__LeftButton",
  componentId: "sc-4yw4dk-1"
})(["border-top-right-radius:0;border-bottom-right-radius:0;flex:1;min-width:auto;"]);
exports.LeftButton = LeftButton;
var RightButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "ToggleButtonsstyles__RightButton",
  componentId: "sc-4yw4dk-2"
})(["border-top-left-radius:0;border-bottom-left-radius:0;flex:1;min-width:auto;"]);
exports.RightButton = RightButton;